import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import { Button, Tooltip } from '@mui/material';
import React from 'react';

export default function BrandScrapeButton() {
  return (
    <Tooltip title="Coming soon: the platform will suggest a logo and colours from a website address.">
      <span>
        <Button
          startIcon={<AutoFixHighOutlinedIcon />}
          variant="outlined"
          disabled
          sx={{ whiteSpace: 'nowrap' }}
        >
          From a website (coming soon)
        </Button>
      </span>
    </Tooltip>
  );
}
